"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
//import { IBonusTemplatePlayerTagsListItem } from "../../ctl/BonusTemplatePlayerTagsListCtl";
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var PromoCodeTemplateLocalisations_1 = require("./locales/PromoCodeTemplateLocalisations");
var PromoCodeTemplateCountries_1 = require("./countries/PromoCodeTemplateCountries");
var PromoCodeTemplateBonusesList_1 = require("./bonuses/PromoCodeTemplateBonusesList");
var PromoCodeTemplateCodesList_1 = require("./codes/PromoCodeTemplateCodesList");
var PromoCodeTemplateCodesLogsList_1 = require("./logs/PromoCodeTemplateCodesLogsList");
var PromoCodeTemplateAmounts_1 = require("./amounts/PromoCodeTemplateAmounts");
var PromoCodeOperationsConfig = /** @class */ (function (_super) {
    __extends(PromoCodeOperationsConfig, _super);
    //private SID_BT: number;
    function PromoCodeOperationsConfig(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_promocode_locales = "promocode.locales";
        _this.tab_promocode_countries = "promocode.countries";
        _this.tab_promocode_bonuses = "promocode.bonuses";
        _this.tab_promocode_codes = "promocode.codes";
        _this.tab_promocode_amounts = "promocode.amounts";
        return _this;
    }
    PromoCodeOperationsConfig.prototype.componentWillMount = function () {
        this.setState({
            promoCodesMode: "LIST",
            promoCodesCode: null,
        });
        this.props.state.setExtBreadCrumbPath(["Настройки промокодов"]);
    };
    PromoCodeOperationsConfig.prototype.componentWillUnmount = function () {
        //this.props.listAvailAppCurrency.UnSubscribe(this.SID_AC);
    };
    PromoCodeOperationsConfig.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    PromoCodeOperationsConfig.prototype.getPromoCodeLocalesObject = function () {
        return (React.createElement(PromoCodeTemplateLocalisations_1.default, { state: this.props.state, dataLocales: this.props.dataLocales, onGoBackClick: this.backToRootClick.bind(this), listAppLanguages: this.props.listAppLanguages, record: this.props.rootRecord }));
    };
    PromoCodeOperationsConfig.prototype.getPromoCodeCountriesObject = function () {
        return (React.createElement(PromoCodeTemplateCountries_1.default, { state: this.props.state, dataCountries: this.props.dataCountries, onGoBackClick: this.backToRootClick.bind(this), listAppCountries: this.props.listAppCountries, record: this.props.rootRecord }));
    };
    PromoCodeOperationsConfig.prototype.getPromoCodeBonusObject = function () {
        return (React.createElement(PromoCodeTemplateBonusesList_1.default, { data: this.props.dataBonuses, state: this.props.state, record: this.props.rootRecord, onGoBackClick: this.backToRootClick.bind(this), dlgSelectBonusTemplate: this.props.dlgSelectBonusTemplate, dlgDescriptionEditor: this.props.dlgDescriptionEditor, listPromoBonusesTemplatesAvail: this.props.listPromoBonusesTemplatesAvail }));
    };
    PromoCodeOperationsConfig.prototype.onHistoryClick = function (record) {
        this.setState({ promoCodesMode: "HISTORY", promoCodesCode: record });
    };
    PromoCodeOperationsConfig.prototype.onGoBackToCodesClick = function (record) {
        this.setState({ promoCodesMode: "LIST", promoCodesCode: null });
    };
    PromoCodeOperationsConfig.prototype.getPromoCodeCodesObject = function () {
        if (this.state.promoCodesMode == "LIST") {
            return (React.createElement(PromoCodeTemplateCodesList_1.default, { data: this.props.dataPromoCodes, state: this.props.state, record: this.props.rootRecord, onGoBackClick: this.backToRootClick.bind(this), dlgDescriptionEditor: this.props.dlgDescriptionEditor, dlgGeneratePromoCode: this.props.dlgGeneratePromoCode, onViewLogsClick: this.onHistoryClick.bind(this), glgGenerateOnePromoCode: this.props.glgGenerateOnePromoCode, dialogSetPromoPartner: this.props.dialogSetPromoPartner, dlgPromoCodeExpiration: this.props.dlgPromoCodeExpiration, dlgExport: this.props.dlgExport }));
        }
        if (this.state.promoCodesMode == "HISTORY") {
            return (React.createElement(PromoCodeTemplateCodesLogsList_1.default, { data: this.props.dataLogs, state: this.props.state, record: this.state.promoCodesCode, onGoBackClick: this.onGoBackToCodesClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.promoCodesMode;
    };
    PromoCodeOperationsConfig.prototype.getPromoCodeAmountsObject = function () {
        return (React.createElement(PromoCodeTemplateAmounts_1.default, { state: this.props.state, dataAmounts: this.props.dataPromoTypeAmounts, onGoBackClick: this.backToRootClick.bind(this), listAppCurrency: this.props.listAppCurrency, record: this.props.rootRecord }));
    };
    PromoCodeOperationsConfig.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_promocode_locales },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "font" }),
                        "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438"), key: this.tab_promocode_locales }, this.getPromoCodeLocalesObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "globe" }),
                        "\u0421\u0442\u0440\u0430\u043D\u044B"), key: this.tab_promocode_countries }, this.getPromoCodeCountriesObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "gift" }),
                        "\u0411\u043E\u043D\u0443\u0441\u044B"), key: this.tab_promocode_bonuses }, this.getPromoCodeBonusObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "qrcode" }),
                        "\u041A\u043E\u0434\u044B"), key: this.tab_promocode_codes }, this.getPromoCodeCodesObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "wallet" }),
                        "\u0421\u0443\u043C\u043C\u044B \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0432"), key: this.tab_promocode_amounts, disabled: !this.props.rootRecord.is_restrict_by_deposit_total_amount_during_deposit_age }, this.getPromoCodeAmountsObject()))));
    };
    return PromoCodeOperationsConfig;
}(React.Component));
exports.default = PromoCodeOperationsConfig;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/component/PromoCodeOperationsConfig.tsx
// module id = 1962
// module chunks = 0